
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface CalendarHeaderProps {
  displayDate: Date;
  onNavigate: (direction: 'prev' | 'next') => void;
}

const CalendarHeader = ({ displayDate, onNavigate }: CalendarHeaderProps) => {
  const currentMonth = format(displayDate, "MMMM yyyy");
  
  return (
    <div className="flex items-center justify-between">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onNavigate('prev')}
        className="text-xs w-24 px-2 flex items-center justify-center"
      >
        <ChevronLeft className="h-4 w-4 mr-1" />
        Prev
      </Button>
      <span className="text-sm font-medium min-w-32 text-center">
        {currentMonth}
      </span>
      <Button
        variant="outline"
        size="sm"
        onClick={() => onNavigate('next')}
        className="text-xs w-24 px-2 flex items-center justify-center"
      >
        Next
        <ChevronRight className="h-4 w-4 ml-1" />
      </Button>
    </div>
  );
};

export default CalendarHeader;
